export const formatDocumentNumber = (document = '') => {
  const documentNumberToString = String(document)

  if (documentNumberToString?.length === 14) {
    return documentNumberToString.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
      );
    }

    if (documentNumberToString?.length === 11) {
      return documentNumberToString.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4'
      );
    }

    return documentNumberToString
};
